import { RandomId } from "@swivl-mono/helpers";
import { NodeInterface } from "@swivl-mono/types";

import UserVariablesDropdown from "../../../../Components/Dropdowns/UserVariablesDropdown/UserVariablesDropdown";
import { TagInput } from "../../../../Components/TagInput/TagInput";
import TabNodeLayoutData from "../NodeLayouts/TabNodeLayoutData";
import InspectorFooter from "../SidePanel/Inspector/components/InspectorFooter";
import InspectorNodeHeader from "../SidePanel/Inspector/components/InspectorNodeHeader";
import NodePanel from "./NodePanel";

const StoreLead = {
  Type: "storeLead",
  Empty: function () {
    let node = {
      id: RandomId(6),
      type: StoreLead.Type,
      goto: "",
      locationCodeVariableId: "StoreId",
      nameVariableId: "Entity personName",
      emailVariableId: "Entity email",
      phoneVariableId: "Entity phonenumber",
      notes: "",
      invalidGoto: ""
    };

    return node; //
  },
  PlumbData: function (node: NodeInterface) {
    const tabs = [
      {
        id: "goto",
        source: "goto",
        target: node.goto,
        title: "Success"
      },
      {
        id: "invalidGoto",
        source: "invalidGoto",
        target: node.invalidGoto,
        title: "Invalid"
      }
    ];

    return TabNodeLayoutData({
      node: node,
      title: "Create Lead",
      baseWidth: 150,
      tabs: tabs
    });
    // const  data = TabbedNodePlumbDataHelper(nodes, node, "", "Create Lead", node.text, tabs, 150)
    // return data;
  },
  InspectorPanel: class InputInspectorPanel extends NodePanel {
    constructor(props: any) {
      super(props);
    }

    render() {
      // const app = AppsModel.getApp("siteLink")

      return (
        <div>
          <div className="panel message_panel">
            <InspectorNodeHeader title="Create Lead" />
            <label>
              Store Location Code<span style={{ color: "#F67902" }}>*</span>
            </label>
            <UserVariablesDropdown
              onChange={this.onChange}
              skipUserId={true}
              name={"locationCodeVariableId"}
              value={this.props.node.locationCodeVariableId}
            />
            <label>
              Name<span style={{ color: "#F67902" }}>*</span>
            </label>
            <UserVariablesDropdown onChange={this.onChange} skipUserId={true} name={"nameVariableId"} value={this.props.node.nameVariableId} />
            <label>Email</label>
            <UserVariablesDropdown onChange={this.onChange} skipUserId={true} name={"emailVariableId"} value={this.props.node.emailVariableId} />
            <label>Phone</label>
            <UserVariablesDropdown onChange={this.onChange} skipUserId={true} name={"phoneVariableId"} value={this.props.node.phoneVariableId} />
            <TagInput
              label="Notes"
              key={"notes"}
              value={this.props.node.notes}
              onChange={this.onChange}
              name="notes"
              helperText="To add a variable, type #"
            />

            <div style={{ marginTop: "10px", textAlign: "center" }}>
              <span style={{ color: "#F67902" }}>*</span> Required Variables
            </div>
          </div>
          <InspectorFooter
            deleteNode={this.deleteNode}
            node={this.props.node}
            duplicateNode={this.props.duplicateNode}
            canDuplicate={this.props.canDuplicate}
          />
        </div>
      );
    }
  }
};
export default StoreLead;
